module.exports = {"id":"202316","name":"Timmy Chandler","rating":"77","photo":"./data/images/photos/4/202316.png","club":{"name":"Eint. Francfort","logo":"./data/images/clubs/Eint.Francfort.png"},"positions":["DD","DLD","MD","DLG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TimmyChandler0.json
// module id = 4137
// module chunks = 0